import { render, staticRenderFns } from "./ArticoloSearch.vue?vue&type=template&id=27fa7730&scoped=true&"
import script from "./ArticoloSearch.vue?vue&type=script&lang=js&"
export * from "./ArticoloSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fa7730",
  null
  
)

export default component.exports